import { useAtomValue } from "jotai";
import { participantCountAtom, recordingStateAtom } from "../../video-sdk";
import { useCanProviderUseTranscription } from "../../provider/session-recording/useCanProviderUseTranscriptionCallback";

export function useRecordingControl(hasAppointment: boolean = false) {
  const recordingState = useAtomValue(recordingStateAtom).value;
  const inSession = !!useAtomValue(participantCountAtom);
  const canProviderUseTranscription = useCanProviderUseTranscription();
  const isVisible = inSession && hasAppointment && canProviderUseTranscription;

  return {
    isVisible,
    recordingState,
  };
}
